<template>
  <div>
    <zj-layout-container v-loading="loading" element-loading-text="加载中...">
      <zj-layout-header>
        <div class="listtitle">{{ title }}</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="用户名" prop="userName">
            <el-input
              v-model="queryParams.userName"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>

          <el-form-item label="登录IP" prop="operationIp">
            <el-input
              v-model="queryParams.operationIp"
              placeholder="请输入IP"
            ></el-input>
          </el-form-item>
          <el-form-item label="操作详情" prop="details" v-if="project=='hongqifang'">
            <el-input
              v-model="queryParams.details"
              placeholder="请输入操作详情"
            ></el-input>
          </el-form-item>
          <el-form-item label="统计时间段">
            <el-date-picker
              v-model="dateRange"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 60rem"
              unlink-panels
              :clearable="false"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">重 置</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="operationLogList" border style="width: 100%" fixed>
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column prop="userName" label="用户名"></el-table-column>
              <el-table-column
                prop="operationTime"
                label="操作时间"
              ></el-table-column>
              <el-table-column
                prop="operationIp"
                label="登录IP"
              ></el-table-column>
              <el-table-column prop="operation" label="操作"></el-table-column>
              <el-table-column
                prop="details"
                label="操作详情"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { listOperationLog } from "@/api/system/permission/log";
export default {
  name: "LogView",
  controller: "UI",
  action: "LogView",
  props: {
    fullPath: String,
    path: String,
    query: Object,
    hash: String,
    targetUrl: String,
    targetUri: Object,
    menu: Object,
  },
  data() {
    return {
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 日历时间
      dateRange: null,
      // 查询参数
      queryParams: {
        userName: null,
        operationIp: null,
        details: null,
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10,
      },
      // 区域数据
      regionData: [],
      // 表格数据
      operationLogList: [],
      Status: 0,
      title: "",
     project: global.$config.app.project
    };
  },
  watch: {
    query(newV) {
      // console.log(newV.Status);
      this.Status = parseInt(newV.Status);
      this.title = this.Status === 0 ? "操作日志" : "错误日志";
      this.getList();
    },
  },
  created() {
    this.Status = parseInt(this.query.Status);
    this.title = this.Status === 0 ? "操作日志" : "错误日志";
    this.getList();
  },
  methods: {
    // 查询
    getList() {
      this.loading = true;
      this.queryParams.startTime =
        this.dateRange != null ? this.dateRange[0] : null;
      this.queryParams.endTime =
        this.dateRange != null ? this.dateRange[1] : null;
      this.queryParams.status = this.Status;
      listOperationLog(this.queryParams).then((response) => {
        this.operationLogList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 点击查询按钮
    onSearch() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 点击清理按钮
    onCancel() {
      this.resetForm("queryForm");
      this.dateRange = null;
      this.onSearch();
    },
    // 点击每页显示的条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
::v-deep .el-form-item {
  vertical-align: top;
}
</style>
<style>
.el-picker-panel .el-picker-panel__footer .el-picker-panel__link-btn.el-button--mini.is-plain {
  color: #409eff;
  border-color: #409eff;
  background-color: #fff;
}
.el-picker-panel .el-picker-panel__footer .el-picker-panel__link-btn.el-button--mini.is-plain:hover {
  color: #66b1ff;
  border-color: #66b1ff;
  background-color: #fff;
}
</style>
